import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from '@fluentui/react/lib/Link';
import generateLinkStyle from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateLinkStyle';
import { openWebLocation, isWebUrl } from '../utils/webLocationUtils';
import { WebUrlLocationProps } from 'owa-location-placeholder';

const styles = require('./WebUrlLocation.scss');
const classNames = require('classnames');

export default observer(function WebUrlLocation(props: WebUrlLocationProps) {
    const { location, className, colorScheme } = props;
    const tokenDivs = location.match(/\S+/g).map((token, index) => (
        <div className={styles.webUrlLocationToken} key={index}>
            {isWebUrl(token) ? (
                <Link
                    className={classNames(styles.linkLocation, className)}
                    styles={colorScheme ? generateLinkStyle(colorScheme) : undefined}
                    onClick={openWebLocation(token)}>
                    {token}
                </Link>
            ) : (
                token
            )}
        </div>
    ));
    return <div className={styles.webUrlLocationTokensContainer}>{tokenDivs}</div>;
});
